import { useState } from 'react';

import { useAutoAnimate } from '@formkit/auto-animate/react';
import { formatPrice } from '@hubmaster/tools';
import { TrendingDown, TrendingUp } from 'lucide-react';

import { formatDecimals, handleInputDecimals } from './functions';

export function Input({ price, register }: { price: number; register: any }) {
	const [inputValue, setInputValue] = useState(formatDecimals(price));
	const [parent] = useAutoAnimate(/* optional config */);

	const newPrice = Number(inputValue.replace(/\./g, '').replace(',', '.'));

	return (
		<div className="flex flex-col items-center gap-2" ref={parent}>
			<div className="flex w-28 items-center border-b-2 border-primary p-1">
				<span className="text-sm text-zinc-600">R$</span>
				<input
					{...register('price', {
						setValueAs: (value: string) => {
							const newValue = handleInputDecimals(value);
							setInputValue(newValue);

							return newValue;
						},
					})}
					id={'inputPrice'}
					type="text"
					inputMode="decimal"
					className="w-full border-none text-center text-xl outline-none"
					placeholder="0,00"
					value={inputValue}
					autoFocus
					onFocus={(event) => event.currentTarget.select()}
				/>
			</div>
			{formatPrice(price) != formatPrice(inputValue) && (
				<div className="flex flex-col items-center justify-center gap-1">
					<p className="text-xs text-zinc-600">
						Preço anterior:{' '}
						<strong className="font-semibold">{formatPrice(price)}</strong>
					</p>
					<div className="flex items-center gap-1">
						{newPrice > price ? (
							<TrendingUp size={16} className="text-green-500" />
						) : (
							<TrendingDown size={16} className="text-red-500" />
						)}
						<p className="text-xs text-zinc-600">
							{((newPrice / price) * 100 - 100).toFixed(2)}%
						</p>
					</div>
				</div>
			)}
		</div>
	);
}
